import React, { Component } from "react";
import Typed from "react-typed";

import MediumIcon from "../images/medium-128.png";
import GithubIcon from "../images/github-128.png";
import GmailIcon from "../images/gmail-128.png";
import LinkedinIcon from "../images/linkedin-128.png";
import TwitterIcon from "../images/twitter.png";

class HomePageComponent extends Component {
  constructor() {
    super();
    this.state = {
      typingText: ["GIT", "VUE", "NODE", "REACT", "JAVA", "RAILS"],
      date: "",
    };
  }
  componentDidMount() {
    this.setState({
      date: new Date().toDateString(),
    });
    if (
      /Chrome/.test(window.navigator.userAgent) ||
      /Firefox/.test(window.navigator.userAgent)
    ) {
      // Some random colors
      const colors = ["#3CC157", "#2AA7FF", "#1B1B1B", "#FCBC0F", "#F85F36"];

      const numBalls = 120;
      const balls = [];

      for (let i = 0; i < numBalls; i++) {
        let ball = document.createElement("div");
        ball.classList.add("ball");
        ball.style.background =
          colors[Math.floor(Math.random() * colors.length)];
        ball.style.left = `${Math.floor(Math.random() * 85)}vw`;
        ball.style.top = `${Math.floor(Math.random() * 100)}vh`;
        ball.style.transform = `scale(${Math.random()})`;
        ball.style.width = `${Math.random()}em`;
        ball.style.height = ball.style.width;

        balls.push(ball);
        document.body.append(ball);
      }

      // Keyframes
      balls.forEach((el, i, ra) => {
        let to = {
          x: Math.random() * (i % 2 === 0 ? -11 : 11),
          y: Math.random() * 12,
        };

        el.animate(
          [
            { transform: "translate(0, 0)" },
            { transform: `translate(${to.x}rem, ${to.y}rem)` },
          ],
          {
            duration: (Math.random() + 1) * 2000, // random duration
            direction: "alternate",
            fill: "both",
            iterations: Infinity,
            easing: "ease-in-out",
          }
        );
      });
    }
  }

  render() {
    return (
      <div className="home-page-layout" style={{ zIndex: "0" }} id="home">
        <div className="homepage-content-container">
          <div className="m-auto">
            <div className="d-flex align-home-page-layout">
              <div className="w-100">
                <div className="d-flex justify-content-center ">
                  <h4
                    className="full-stack-developer text-center"
                    style={{ color: "#CCCC00" }}
                  >
                    Bringing your digital dreams to life with a Full Stack of
                    skills
                  </h4>
                </div>
              </div>
            </div>
            <div className="homepage-description d-flex justify-content-center">
              <h1>
                <span style={{ color: "#C0C0C0" }}>I USE TECH </span>
                <sup>
                  <Typed
                    strings={this.state.typingText}
                    typeSpeed={70}
                    backSpeed={70}
                    style={{ color: "orange" }}
                    loop
                  />
                </sup>{" "}
                <span style={{ color: "#C0C0C0" }}>TO WRITE MY STORIES</span>
              </h1>
            </div>
            <div className="d-flex justify-content-center mt-5">
              <div className="ml-4 social-media-icons">
                <a
                  href="https://www.linkedin.com/in/hardik-chugh-977a7b14b/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LinkedinIcon} alt="linkedin" id="linkedin" />
                </a>
              </div>
              <div className="ml-4 social-media-icons">
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&su=Let's Connect Hardik&body=Hey Hardik!"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GmailIcon} alt="gmail" id="gmail" />
                </a>
              </div>
              <div className="ml-4 social-media-icons">
                <a
                  href="https://github.com/hardy1334/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GithubIcon} alt="github" id="github" />
                </a>
              </div>
              <div className="ml-4 social-media-icons">
                <a
                  href="https://medium.com/@chughhardik"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={MediumIcon} alt="medium" id="medium" />
                </a>
              </div>

              <div className="ml-4 social-media-icons">
                <a
                  href="https://twitter.com/haarrdiik"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={TwitterIcon} alt="facebook" id="twitter" />
                </a>
              </div>
            </div>
          </div>
          <div className="d-flex home-page-quote">
            <center>
              <h3 className="quote">“Talk is cheap. Show me the Code.”</h3>
              <small style={{ color: "#FFCCCC", fontSize: "20px" }}>
                ― Linus Torvalds
              </small>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePageComponent;
